import React, { useState } from 'react';
import { Row, Col, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
//icons
import { FaCrosshairs } from 'react-icons/fa';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
//components
import { InputCustom } from '../input';
//images
import map from '../../assets/img/mapa.png';
//styles
import './findLibraries.scss';

const FindLibraries = () => {
  const { t } = useTranslation(['footer']);
  const [searchQuery, setSearchQuery] = useState('');
  const { assignedLibrary } = useAssignedLibrary();

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    <Container className="findLibRow w-100 px-0 container-fluid">
      <div className='container container-responsive col-12'>
        <Row className="pt-5 pb-4">
          <Col md={6} xs={12} className="d-flex align-items-center">
            <div className='libreries-content'>
              <h4>
                <strong>{t('libraryFavorite')}</strong>
              </h4>
              <div className="search-container">
                <InputCustom
                  type="text"
                  placeholder={t('direccionCiudadLocalidad')}
                  className="mt-2 search-input"
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
              </div>
              <div className="d-flex align-items-center mt-2 facross-p">
                <Link to={{
                  pathname: `/${assignedLibrary}/librerias/mapa`,
                  search: '?geolocationEnabled=true'
                }} className="d-flex mr-3 text-decoration-none">
                  <FaCrosshairs />
                  <p className='mb-0 libreries-text global-link'>{t('cercaDeAqui')}</p>
                </Link>
              </div>
            </div>
          </Col>
          <Col md={6} xs={12}>
            <div className='libreries-content-new'>
              <img src={map} alt="apps.png" data-testid="imagemap" />
            </div>
          </Col>
        </Row>
        <Row className="pb-5">
          <Col md={12} className="text-center">
            <Link to={{
              pathname: `/${assignedLibrary}/librerias/mapa`,
              search: searchQuery !== '' && `?address=${encodeURIComponent(searchQuery)}`
            }}>
              <Button className="py-2">{t('irAlMapa')}</Button>
            </Link>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default FindLibraries;
